import React from "react";
import { useDispatch } from "react-redux";
import { closeModal } from "../redux/features/modalSlice";

const KycStatusConfirmModal = ({ data, title }) => {
  const dispatch = useDispatch();

  const handleConfirm = () => {
    dispatch(closeModal());
    if (data?.onConfirm) {
      setTimeout(() => {
        data.onConfirm();
      }, 100);
    }
  };

  return (
    <div className="card p-3 text-center">
      <p className="mb-4" style={{ fontSize: "15px" }}>
        Are you sure you want to change KYC status from{" "}
        <strong className="text-capitalize">
          {data?.currentStatus || "pending"}
        </strong>{" "}
        to{" "}
        <strong className="text-capitalize">{data?.newStatus}</strong>?
      </p>

      <div className="d-flex justify-content-center gap-2">
        <button
          className="btn btn-secondary"
          onClick={() => dispatch(closeModal())}
        >
          Cancel
        </button>

        <button className="add-btn" onClick={handleConfirm}>
          Yes, Continue
        </button>
      </div>
    </div>
  );
};

export default KycStatusConfirmModal;